// extracted by mini-css-extract-plugin
export default {"item":"RTList-item-1IOyA","itemContentRoot":"RTList-itemContentRoot-3niuQ"};